import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Services } from "@/components/site/Services";
import { Manifesto } from "@/components/site/Manifesto";
import { About } from "@/components/site/About";
import { HelpingFamilies } from "@/components/site/HelpingFamilies";
import { KonnectStrip, ATTStrip, CommunityStrip, IPhone18Strip, MedsStrip } from "@/components/site/HomeStrips";
import { Testimonials } from "@/components/site/Testimonials";
import { Faq } from "@/components/site/Faq";
import { Stats } from "@/components/site/Stats";
import { Contact } from "@/components/site/Contact";

export default function Home() {
  return (
    <>
      <Hero />
      <IPhone18Strip />
      <MedsStrip />
      <Marquee />
      <ATTStrip />
      <Services />
      <KonnectStrip />
      <Manifesto />
      <About />
      <HelpingFamilies />
      <CommunityStrip />
      <Testimonials />
      <Faq />
      <Stats />
      <Contact />
    </>
  );
}
